// -----------------------------------------------------------------------------
// DATETIMEPICKER
// 
// See more examples on https://flatpickr.js.org/examples
// -----------------------------------------------------------------------------

import flatpickr from "flatpickr";

window.initDatepicker = function(){
  flatpickr('.js-input-datepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: false,
    dateFormat: "d/m/Y"
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Datepicker initialized`);
  }
}

window.initFtDateTimepicker = function(){
  flatpickr('.js-input-future-datetimepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: true,
    dateFormat: "d/m/Y H:i",
    time_24hr: true,
    minuteIncrement: 1,
    minDate: new Date().fp_incr(1)
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Datetimepicker initialized`);
  }
}

window.initDateTimepicker = function(){
  flatpickr('.js-input-datetimepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: true,
    dateFormat: "d/m/Y H:i",
    time_24hr: true,
    minuteIncrement: 1
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Datetimepicker initialized`);
  }
}

window.initTimepicker = function(){
  flatpickr('.js-input-timepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    minuteIncrement: 1
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Timepicker initialized`);
  }
}

window.initMultipleFtpicker = function(options={}){
  options.declinedDates = options.declinedDates || [];
  options.onlyFuture = options.onlyFuture === false ? false : true;

  // Convert declined dates from YYYY-MM-DD to Date objects for Flatpickr
  const declinedDateObjects = options.declinedDates.map(dateStr => {
    const [year, month, day] = dateStr.split('-');
    return new Date(year, month - 1, day);
  });

  // Build disable array
  const disableRules = [...declinedDateObjects];
  
  // Add weekday filtering if specified
  if (options.weekday === 'weekend') {
    // Disable workdays (Mon-Thu: 1-4)
    disableRules.push(function(date) {
      const day = date.getDay();
      return day >= 1 && day <= 4;
    });
  } else if (options.weekday === 'workdays') {
    // Disable weekends (Fri-Sun: 5,6,0)
    disableRules.push(function(date) {
      const day = date.getDay();
      return day === 5 || day === 6 || day === 0;
    });
  }

  flatpickr('.js-input-multiple-futurepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    dateFormat: "d/m/Y",
    mode: "multiple",
    inline: true,
    minDate: options.onlyFuture ? "today" : null,
    disable: disableRules,
    onDayCreate: function(dObj, dStr, fp, dayElem) {
      const date = dayElem.dateObj;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const dateStr = `${year}-${month}-${day}`;
      
      // Check if this date is in declinedDates
      if (options.declinedDates.includes(dateStr)) {
        console.log('Adding proposed-date class to:', dateStr); // Debug
        dayElem.classList.add('declined-date');
      }
    }
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Timepicker initialized`);
  }
}

window.initFtDatepicker = function(){
  flatpickr('.js-input-futurepicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: false,
    dateFormat: "d/m/Y",
    minDate: new Date().fp_incr(1)
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Futurepicker initialized`);
  }
}

window.pickers_from = []
window.pickers_to = []

window.initRangeDatepicker = function(){
  document.querySelectorAll('.js-input-datepicker-from').forEach(function(element, index){
    window.pickers_from.push(
      flatpickr(element, {
        locale: {
          firstDayOfWeek: 1
        },
        enableTime: false,
        dateFormat: "d/m/Y",
        time_24hr: true,
        onChange: function(selectedDates, dateStr, instance) {
          pickers_to[index].set('minDate', selectedDates[0].fp_incr(1));
        }
      })
    )
  });

  document.querySelectorAll('.js-input-datepicker-to').forEach(function(element, index){
    window.pickers_to.push(
      flatpickr(element, {
        locale: {
          firstDayOfWeek: 1
        },
        enableTime: false,
        dateFormat: "d/m/Y",
        time_24hr: true,
        onChange: function(selectedDates, dateStr, instance) {
          pickers_from[index].set('maxDate', selectedDates[0].fp_incr(-1));
        }
      })
    )
  });

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Rangedatepicker initialized`);
  }
}

window.initHolidaypicker = function(options={}){
  options.disableDates = options.disableDates || [];
  options.proposedDates = options.proposedDates || [];
  options.onlyFuture = options.onlyFuture === false ? false : true;
  
  flatpickr('.js-input-holidaypicker', {
    locale: {
      firstDayOfWeek: 1
    },
    enableTime: false,
    dateFormat: "d/m/Y",
    disable: options.disableDates,
    minDate: options.onlyFuture ? "today" : "",
    mode: "range",
    inline: true,
    onReady: function(selectedDates, dateStr, instance){
      previewDates(selectedDates);
    },
    onChange: function(selectedDates, dateStr, instance) {
      $('.js-holiday-submit').prop('disabled', selectedDates.length < 2);
      $('[data-preview]').text("");
      previewDates(selectedDates);
    },
    onValueUpdate: function() {
      console.log("Value updated");
    },
    onDayCreate: function(dObj, dStr, fp, dayElem) {
      const date = dayElem.dateObj;
      const dateStr = formatDateForComparison(date);
      
      // Check if this date is in proposedDates
      if (options.proposedDates.some(proposedDate => {
        return formatDateForComparison(new Date(proposedDate)) === dateStr;
      })) {
        dayElem.classList.add('proposed-date');
      }
    }
  });

  // Helper function to format dates for comparison
  function formatDateForComparison(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  $('.js-clear-holiday-calendar').on('click', function(){
    $('.js-input-holidaypicker').val("");
    $('[data-preview]').text("");
  })

  $('.js-holiday-submit').prop('disabled', true);

  function previewDates(selectedDates){
    selectedDates.forEach((date, index) => {
      let display = $(`[data-holiday-preview]:eq(${index})`);
      let day = date.getDate();
      let month = I18n.t('date.month_names')[date.getMonth() + 1];
      let year = date.getFullYear();
      let weekday = I18n.t('date.day_names')[date.getDay()];

      display.find('[data-preview="day"]').text(day);
      display.find('[data-preview="month-year"]').text(`${month} ${year}`);
      display.find('[data-preview="weekday"]').text(weekday);
    })
  }

  if (isDevEnvironment()) {
    console.info(`[DEV] Flatpickr Datepicker initialized`);
  }
}
